module.exports = __webpack_public_path__ + "347f0bbcc3d2d377201b587b5e5ca6ed.jpg";